module.exports = __webpack_public_path__ + "static/media/3.bd36bc19.png";